import React, { useState } from "react";
import CrackRep from "./TableView/CrackRep";
import CrackMonthlyReport from "./TableView/CrackMonthlyReport";

const CrackReportMaster = () => {
  return (
    <div className="">
      {" "}
      <div className="newUiBody">{<CrackMonthlyReport />}</div>{" "}
      <div className="newUiBody">{<CrackRep />}</div>
    </div>
  );
};
export default CrackReportMaster;
